import { render, staticRenderFns } from "./LiteratureDatabase.vue?vue&type=template&id=1cf9705b"
import script from "./LiteratureDatabase.vue?vue&type=script&lang=js"
export * from "./LiteratureDatabase.vue?vue&type=script&lang=js"
import style0 from "./LiteratureDatabase.vue?vue&type=style&index=0&id=1cf9705b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports